import { PRODUCT_LIST } from "../action-types/product"

const initProductList = {
    customerDataCulture: [],
    sparcaProducts: [],
    activeProducts: [],
}

export default function productReducer(state = initProductList, action) {
    switch (action.type) {
        case PRODUCT_LIST:
            return {
                ...state,
                customerDataCulture: action.payload.products.customerDataCulture,
                sparcaProducts: action.payload.products.sparcaProducts,
                activeProducts: action.payload.activeProducts,
            }
        default:
            return state
    }
}
